import React, { createContext, useState, useEffect } from 'react';
import { lightTheme, darkTheme } from '../styles/GlobalStyle';

export const ThemeContext = createContext({
  isDarkMode: false,
  theme: lightTheme,
  toggleTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  // Check if user has saved theme preference or use OS preference
  const getInitialTheme = () => {
    // Use light theme as default if running on server or in unsupported environment
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }
    
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    
    // Check if OS prefers dark mode
    return window.matchMedia && 
      window.matchMedia('(prefers-color-scheme: dark)').matches;
  };
  
  const [isDarkMode, setIsDarkMode] = useState(getInitialTheme);
  
  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };
  
  // Store theme preference in localStorage when it changes
  useEffect(() => {
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);
  
  const theme = isDarkMode ? darkTheme : lightTheme;
  
  return (
    <ThemeContext.Provider value={{ isDarkMode, theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider; 